const catData = [
  {
    name: "Vegetables / सब्जी",
    link: "/category/vegetables",
    image: "vegitable.png",
  },
  {
    name: "Fruits / फल",
    link: "/category/fruits",
    image: "fruits.jpg",
  },
  {
    name: "Dairy / डेयरी उत्पाद",
    link: "/category/dairy",
    image: "dairy.jpg",
  },
  {
    name: "Dry Fruits / सूखे फल",
    link: "/category/dry-fruits",
    image: "dry-fruit.jpg",
  },
  {
    name: "Rice / चावल",
    link: "/nano-category/rice",
    image: "rice.jpg",
  },
  {
    name: "Flour / आटा",
    link: "/nano-category/flour",
    image: "flour.jpg",
  },
  {
    name: "Pulse's / दाल",
    link: "/nano-category/pulse",
    image: "pulse.jpg",
  },
  {
    name: "Spices / मसाले",
    link: "/sub-category/masala",
    image: "masala.jpg",
  },
  {
    name: "Cooking Oil",
    link: "/nano-category/oil",
    image: "cooking-oil.jpg",
  },
  {
    name: "Ayurvedic Products",
    link: "/company/Patanjali",
    image: "ayurbedic.jpg",
  },
  {
    name: "Covid Essential",
    link: "/nano-category/handwash-and-sanitizers",
    image: "handwash-and-sanitizer.jpg",
  },
  {
    name: "Tea and Coffee",
    link: "/nano-category/tea-and-coffee",
    image: "tea-coffee.jpg",
  },
  {
    name: "Soft Drinks",
    link: "/nano-category/soft-drinks",
    image: "soft-drinks.jpg",
  },
  {
    name: "Healthy Juice",
    link: "/nano-category/juice",
    image: "juice.jpg",
  },
  {
    name: "Health Essential",
    link: "/sub-category/health-essential",
    image: "health-essensial.jpg",
  },
  {
    name: "Dental Care",
    link: "/nano-category/dental-care",
    image: "dental-care.jpg",
  },
  {
    name: "Beauty and Hygiene",
    link: "/sub-category/beauty-hygiene",
    image: "beauty-hygine.jpg",
  },
  {
    name: "Fragrances and Deos",
    link: "/nano-category/fragrances-deos",
    image: "fragrances-deos.jpeg",
  },
  {
    name: "Hair Care",
    link: "/nano-category/hair-care",
    image: "hare-care.jpeg",
  },
  {
    name: "Face Care",
    link: "/nano-category/face-care",
    image: "face-care.png",
  },
  {
    name: "Household products",
    link: "/sub-category/household-cleaning",
    image: "household-cleaning.jpg",
  },
  {
    name: "Baby Care",
    link: "/sub-category/baby-care",
    image: "baby-care.jpg",
  },
  {
    name: "Kurkure and Chips",
    link: "/nano-category/kurkure-and-chips",
    image: "chips.jpg",
  },
  {
    name: "Bhujia and Mixture",
    link: "/nano-category/bhujia-mixtures",
    image: "bhujia-mixture.jpg",
  },
  {
    name: "Biscuits",
    link: "/nano-category/biscuits",
    image: "biscuts.jpg",
  },
  {
    name: "Chocolate and Candy",
    link: "/sub-category/chocolate-and-candy",
    image: "chocolate.jpg",
  },
  {
    name: "Cake and Pastry",
    link: "/sub-category/cake-and-pastry",
    image: "cake-pastry.png",
  },
  {
    name: "Cookies and Bread",
    link: "/sub-category/cookies-and-bread",
    image: "cookies-bread.jpg",
  },
  // {
  //   name: "Birthday Essential",
  //   link: "/birthday",
  //   image: "birthday.jpg",
  // },
]

export default catData
